import { Component, OnInit } from "@angular/core";
import { DataMigrationService } from "../Services/dataMigration.service";

@Component({
  templateUrl:'./app-success.component.html',
  standalone: false
})
export class SuccessComponent implements OnInit{
  constructor(public data: DataMigrationService) {}
  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
